<!-- footer start-->
<div class="container-fluid">
    <div class="row">
        <div class="col-md-12 footer-copyright text-center">
            <p class="mb-0">Copyright {{ today | date:'y'}} © BIS Open API {{layout.getTenant()}} v.1.6</p>
        </div>
    </div>
</div>